import { class_function_wrapper } from '../internal'
import { Vector } from './Vector.js'

export class Velocity extends Vector {}

export const vel = class_function_wrapper(Velocity)
